import React, { useState, useEffect, useCallback } from "react";
import {
  Form,
  Input,
  Button,
  Typography,
  Card,
  Col,
  Row,
  notification,
  Select,
  Modal,
  message,
} from "antd";

import { useSelector } from "react-redux";
import "./novedades.css";
import cargarDeptosMunicipios from "../../services/departMunic/deptosMunicipiosServices";
import insertNovedad from "../../services/novedades/postNovedadService";
import getTipoNovedades from "../../services/novedades/getTipoNovedadService";
import { updateNovedad } from "../../services/novedades/putNovedad";
import getParticipanteCodigo from "../../services/participants/getParticipanteCodigo";
import obtenerSectoresxActividadesProductivas from "../../services/visitas_tecnicas/getSectoresxActividadesProductivasService";
import FirmaCanvas from "../firma_electronica/firma";
import getNovedadById from "../../services/novedades/getNovedadByIdService";
import { postSoporteNovedad } from "../../services/novedades/postAlmacenarSoporteNovedad";
import PdfAlmacenarNovedad from "./PdfNovedadAlmacenar";
import { pdf } from "@react-pdf/renderer";


const { Title } = Typography;
const { Option } = Select;

const FormularioNovedades = ({ initialData, isEditMode, onClose, fetchData }) => {
  const [form] = Form.useForm();
  const [formLoaded, setFormLoaded] = useState(false);
  const usernameFromState = useSelector((state) => state.auth.user);
  const [codigoSIRR, setCodigoSIRR] = useState("");
  const [listatipoNovedades, setListaTipoNovedades] = useState([]);
  const [datosProyecto, setDatosProyecto] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [codigoSIRRModal, setCodigoSIRRModal] = useState("");

  const [departamentosxmunicipio, setDepartamentosxmunicipio] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [departamentoSeleccionado, setDepartamentoSeleccionado] = useState("");
  const [municipios, setMunicipios] = useState([]);
  const [municipiosNovedad, setMunicipiosNovedad] = useState([]);
  const [isEditing, setIsEditing] = useState(false);

  const [listaSectores, setListaSectores] = useState([]);
  const [
    dataCompletaSectoresxActividadProductiva,
    setDataCompletaSectoresxActividadProductiva,
  ] = useState([]);
  const [listaActividadesProductivas, setListaActividadesProductivas] =
    useState([]);

  const [tipoNovedadSeleccionado, setTipoNovedadSeleccionado] = useState(null);
  const [tipoSectorSelecionado, setTipoSectorSeleccionado] = useState(null);
  const [sectorEconomico_name_cambio, setSectorEconomico_cambio_name] =
    useState(null);
  const [actividadProductiva_cambio_name, setActividadProductiva_cambio_name] =
    useState(null);

      const [isLoading, setIsLoading] = useState(false);


  //maneja el cambio de estado del departamento
  const handleDepartamentoChange = (valor) => {
    setMunicipios([]);
    form.setFieldsValue({ municipio: undefined });
    setDepartamentoSeleccionado(valor);
    const lista_municipios = departamentosxmunicipio.find(
      (dep) => dep.nombre_departamento === valor
    );

    if (lista_municipios && lista_municipios.municipios) {
      // Ordenar la lista de municipios alfabéticamente por nombre
      const municipiosOrdenados = lista_municipios.municipios.sort((a, b) => {
        if (a.nombre_municipio < b.nombre_municipio) return -1;
        if (a.nombre_municipio > b.nombre_municipio) return 1;
        return 0;
      });

      // Actualizar el estado con la lista de municipios ordenada
      setMunicipios(municipiosOrdenados);
    } else {
      setMunicipios([]);
      form.setFieldsValue({ municipio: undefined });
    }
  };

  const cargarSectoresxActividadesProductivas = async () => {
    try {
      const response = await obtenerSectoresxActividadesProductivas();
      if (response.success) {
        setListaSectores(response.sectores);
        setDataCompletaSectoresxActividadProductiva(response);
      } else {
        // Manejar el error, quizás mostrar un mensaje al usuario
        console.error(
          "Error al cargar sectores y actividades productivas:",
          response.message
        );
      }
    } catch (error) {
      console.error("Error al cargar datos:", error);
    }
  };

  // Maneja el cambio de estado del departamento de novedad
  const handleDepartamentoNovedadChange = (valor) => {
    const lista_municipios = departamentosxmunicipio.find(
      (dep) => dep.nombre_departamento === valor
    );

    if (lista_municipios && lista_municipios.municipios) {
      // Ordenar la lista de municipios alfabéticamente por nombre
      const municipiosOrdenados = lista_municipios.municipios.sort((a, b) => {
        if (a.nombre_municipio < b.nombre_municipio) return -1;
        if (a.nombre_municipio > b.nombre_municipio) return 1;
        return 0;
      });

      // Actualizar el estado con la lista de municipios ordenada
      setMunicipiosNovedad(municipiosOrdenados);
    } else {
      setMunicipiosNovedad([]);
    }
  };

  const obtenerdepartamentos = useCallback(async () => {
    try {
      setDepartamentos([]);
      form.setFieldsValue({ departamentos: [] });

      const { data } = await cargarDeptosMunicipios();
      setDepartamentosxmunicipio(data);

      let uniqueDepartamentos = data.map((departamento) => ({
        id: departamento.oid_departamento,
        nombre: departamento.nombre_departamento,
      }));

      setDepartamentos(uniqueDepartamentos);
    } catch (error) {
      console.error("Error al obtener departamentos:", error);
    }
  }, [form]);

  const obtenerTipoNovedades = async () => {
    try {
      setListaTipoNovedades([]);
      form.setFieldsValue({ tipoNovedades: [] });

      const { data } = await getTipoNovedades();
      setListaTipoNovedades(data);
    } catch (error) {
      console.error("Error al obtener tipo de novedades:", error);
    }
  };

  const obtenerActividadesProductivasxSector = async (value) => {
    setTipoSectorSeleccionado(value);
    // Verificar que los datos existen antes de acceder a ellos
    if (
      !dataCompletaSectoresxActividadProductiva ||
      !dataCompletaSectoresxActividadProductiva.actividadesProductivas
    ) {
      console.warn("Los datos de sectores aún no están disponibles");
      setListaActividadesProductivas([]); // Asegura que la lista no tenga valores incorrectos
      return;
    }

    const actividadesFiltradas =
      dataCompletaSectoresxActividadProductiva.actividadesProductivas.filter(
        (actividad) => actividad.sectorId === value
      );

    setListaActividadesProductivas(actividadesFiltradas);
  };

  useEffect(() => {
    const cargarDatos = async () => {
      await obtenerdepartamentos();
      await obtenerTipoNovedades();
      await cargarSectoresxActividadesProductivas(); // Espera a que termine antes de seguir

      if (initialData && Object.keys(initialData).length > 0) {
        form.resetFields();
        setFormLoaded(true);
        setIsEditing(true);

        setTipoSectorSeleccionado(initialData.sector_economico_cambio); // Ahora los sectores ya deberían estar listos
        setTipoNovedadSeleccionado(initialData.tipoNovedad);
        form.setFieldsValue(initialData);
      } else {
        setFormLoaded(false);
        form.resetFields();

        const fechaExistente = form.getFieldValue("fecha_registro");
        if (!fechaExistente) {
          const fechaActual = new Date().toISOString().split("T")[0];
          form.setFieldsValue({ fecha_registro: fechaActual });
        }

        setIsEditing(false);
        setModalVisible(true);
        setTipoNovedadSeleccionado(null);
        setTipoSectorSeleccionado(null);
      }
    };

    cargarDatos();
  }, [form, initialData]); // Quité `obtenerdepartamentos`, `obtenerSectoresxActividadesProductivas` porque ya los llamamos dentro

  useEffect(() => {
    if (tipoSectorSelecionado && listaSectores.length > 0) {
      obtenerActividadesProductivasxSector(tipoSectorSelecionado);
    }
  }, [tipoSectorSelecionado, listaSectores]); // Agregamos `listaSectores` para asegurarnos de que ya tiene datos

  const consultarAPI = async (codigo) => {
    //consulta el codigo sirr en la base de datos
    try {
      const data = await getParticipanteCodigo(codigo);
      if (data.estado) {
        setDatosProyecto(data);
        // Maneja el cambio de estado del departamento
        handleDepartamentoChange(data.departamento);
        form.setFieldsValue({
          nombreProyecto: data.nombre_proyecto,
          nombreParticipante: data.nombre_if,
          departamento: data.departamento,
          municipio: data.municipio,
          codigoPREPP: data.codigo_pre,
          descripcionProyecto: data.descripcion,
        });

        // Mostrar mensaje de éxito
        notification.success({
          message: "Consulta Exitosa",
          description: "Datos encontrados y llenados correctamente.",
        });

        setModalVisible(false); // Cerrar el modal si la consulta es exitosa
      } else {
        notification.error({
          message: "Error",
          description: "El participante no existe.",
        });
        setModalVisible(true); // Mantener el modal abierto si no se encuentra el participante
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "No se encontraron datos para el código ingresado.",
      });
    }
  };

  const handleConsultar = async () => {
    if (!codigoSIRRModal) {
      message.error("Por favor ingrese el código SIRR antes de continuar."); // Mensaje de error si el campo está vacío
      return; // Evitar el cierre del modal
    }
    try {
      await consultarAPI(codigoSIRRModal);
      form.setFieldsValue({ codigoSIRR: codigoSIRRModal });
      setCodigoSIRRModal("");
    } catch (error) {
      message.error({
        message: "Error",
        description: "No se pudo realizar la consulta. Intente nuevamente.",
      });
    }
  };

  const fetchNovedadById_pdf = async (id) => {
    try {
      const response = await getNovedadById(id);
      const { status, data } = response;

      if (status) {
        return data;

      } else {
        return null;
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    }
  };

  const enviarPDFAlServidor = async (id) => {
    try {
      let data = await fetchNovedadById_pdf(id);

      let blob = await pdf(
        <PdfAlmacenarNovedad formData={data} />
      ).toBlob();

      const nombreArchivo = `7_Novedad_${id}_${data.fecha_archivo}.pdf`;
      const formDataToSend = new FormData();
      formDataToSend.append(
        "ruta",
        `${data.fecha_directorio}/${data.departamento_p}/${data.codigo_pre}/`
      );
      formDataToSend.append("nombre_archivo", nombreArchivo);
      formDataToSend.append("file", blob, nombreArchivo);

      const response = await postSoporteNovedad(formDataToSend, data.id);
      return response;
    } catch (err) {
      console.error("❌ Error al enviar el PDF:", err);
    }
  };
  
const onFinish = async () => {
  if (isLoading) return; // 🔒 evita doble submit

  setIsLoading(true);

  try {
    const values = form.getFieldsValue();

    if (isEditMode === true) {
      await actualizarNovedad(values);
    } else {
      await insertarNovedad(values);
    }
  } finally {
    setIsLoading(false); // 🔓 SIEMPRE se libera
  }
};


  // Función optimizada para insertar una nueva novedad
// ✅ Función optimizada para insertar una novedad y enviar soporte si es exitosa
const insertarNovedad = async (values) => {
  // ⚠️ Validar autenticación
  if (!usernameFromState.email) {
    notification.error({
      message: "Error",
      description: "Acceso denegado. Inicia sesión.",
    });
    return;
  }

  const { tipoNovedad } = values;

  const baseData = {
    ...values,
    user_email: usernameFromState.email,
    fuente: "Web",
  };

  const data =
    tipoNovedad === 3
      ? {
          ...baseData,
          name_sector_economico_cambio: sectorEconomico_name_cambio,
          name_actividad_productiva_cambio: actividadProductiva_cambio_name,
        }
      : baseData;

  const respuesta = await insertNovedad(
    data,
    tipoNovedad,
    datosProyecto.oid,
    datosProyecto.id_proyecto
  );

  if (respuesta.status !== 200) {
    notification.error({
      message: "Error",
      description: "No se pudo guardar la novedad.",
    });
    return;
  }

  const respuestaPDF = await enviarPDFAlServidor(respuesta.id);

  if (respuestaPDF.status !== 200) {
    notification.error({
      message: "Error al subir PDF",
      description:
        "Se guardó la novedad, pero hubo un problema con el PDF.",
    });
    return;
  }

  notification.success({
    message: "Éxito",
    description: "Novedad guardada correctamente.",
  });

  onClose();
  fetchData();
};



// ✅ Función optimizada para actualizar una novedad y enviar soporte si es exitosa
const actualizarNovedad = async (values) => {
  try {
    // 🎯 Preparar los datos para actualizar
    const data = {
      ...values,
      user_email: usernameFromState.email,
      fuente: initialData.fuente,
    };

    // 🚀 Actualizar la novedad

    const respuesta = await updateNovedad(initialData.id, data);

    // ⚙️ Validar si la actualización fue exitosa
    if (respuesta.status !== 200) {
      notification.error({
        message: "Error",
        description: "No se pudo actualizar la novedad. Inténtalo nuevamente.",
      });
      return;
    }

    // 📄 Generar y enviar el PDF solo si la actualización fue exitosa
    const respuestaPDF = await enviarPDFAlServidor(initialData.id);

    if (respuestaPDF.status !== 200) {
      notification.error({
        message: "Error al subir PDF",
        description: "La novedad se actualizó correctamente, pero hubo un problema al generar o subir el archivo PDF.",
      });
      return;
    }

    // ✅ Notificar éxito completo
    notification.success({
      message: "Éxito",
      description: "Novedad actualizada correctamente.",
    });

    // 🔄 Cerrar modal y refrescar datos
    onClose();
    fetchData();

  } catch (error) {
    console.error("❌ Error al actualizar la novedad:", error);

    notification.error({
      message: "Error",
      description: "No se pudo actualizar la novedad. Inténtalo nuevamente.",
    });
  }
};



  // Maneja el cambio de selección del tipo de novedad
  const handleTipoNovedadChange = (value) => {
    form.setFieldsValue({
      sector_economico_cambio: "",
      ActividadesProductivas_cambio: "",
      nombreProyecto_cambio: "",
      descripcionProyecto_cambio: "",
    });

    form.setFieldsValue({
      sector_economico: datosProyecto.sector,
      actividad_productiva: datosProyecto.actividad_productiva,
    });

    setTipoSectorSeleccionado(false);
    setTipoNovedadSeleccionado(value);
  };

  return (
    <div className="form-container">
      <Card className="form-card">
        <Title level={2} className="main-title">
          REPORTE DE NOVEDAD
        </Title>

        <Form form={form} onFinish={onFinish} layout="vertical">
          {isEditMode !== null && (
  <div style={{ textAlign: "center", marginTop: "40px" }}>
    <Button
      type="primary"
      htmlType="submit"
      disabled={isLoading}
      style={{
        backgroundColor: "#52c41a",
        borderColor: "#52c41a",
      }}
    >
      {isEditMode === true
        ? "Actualizar Novedad"
        : "Guardar Novedad"}
    </Button>
  </div>
)}


          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Fecha de Registro"
                name="fecha_registro"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la fecha de registro",
                  },
                ]}
              >
<Input disabled={isEditMode !== true} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Código -SIRR"
                name="codigoSIRR"
                style={{ display: "flex", alignItems: "center" }}
              >
                <Input
                  value={codigoSIRR}
                  disabled
                  style={{ flex: 1, marginRight: "8px" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Nombre Completo Del Titular Del Proyecto"
                name="nombreParticipante"
                rules={[
                  {
                    required: true,
                    message:
                      "Por favor ingrese el nombre del titular del proyecto",
                  },
                ]}
              >
<Input disabled={isEditMode !== false} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Número de identificación"
                name="numeroIdentificacion"
              >
                <Input type="number" disabled={isEditMode !== false} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="Nombre Del Proyecto"
                name="nombreProyecto"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre del proyecto",
                  },
                ]}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Departamento"
                name="departamento"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione un departamento",
                  },
                ]}
              >
                <Select
                  disabled={isEditMode !== false}
                  onChange={handleDepartamentoChange}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {departamentos.map((depto) => (
                    <Option key={depto.id} value={depto.nombre}>
                      {depto.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Municipio"
                name="municipio"
                rules={[
                  {
                    required: false,
                    message: "Por favor seleccione un municipio",
                  },
                ]}
              >
                <Select
                 disabled={isEditMode !== false}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {municipios.map((mun) => (
                    <Option
                      key={mun.nombre_municipio}
                      value={mun.nombre_municipio}
                    >
                      {mun.nombre_municipio}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Vereda" name="vereda">
                <Input disabled={isEditMode !== false} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Código PRE-PP" name="codigoPREPP">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Descripción del proyecto"
                name="descripcionProyecto"
              >
                <Input.TextArea rows={7} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Tipo de Novedad"
                name="tipoNovedad"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione un tipo de novedad",
                  },
                ]}
              >
                <Select
                  disabled={isEditMode !== false}
                  showSearch
                  value={tipoNovedadSeleccionado}
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={handleTipoNovedadChange}
                >
                  {listatipoNovedades.map((tipo) => (
                    <Option key={tipo.id} value={tipo.id}>
                      {tipo.tipo_novedad}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {tipoNovedadSeleccionado === 3 && (
            <>
              <Row gutter={16}>
                <Col xs={12} sm={12}>
                  <h1
                    style={{
                      color: "#338BC7",
                      marginTop: "20px",
                      fontSize: "25px",
                    }}
                  >
                    Datos actuales
                  </h1>
                  <Form.Item
                    label="Sector económico actual"
                    name="sector_economico"
                  >
                    <Input disabled={isEditMode !== false} />
                  </Form.Item>

                  <Form.Item
                    label="Actividad productiva actual"
                    name="actividad_productiva"
                  >
                    <Input disabled={isEditMode !== false} />
                  </Form.Item>

                  <label style={{ padding: "0 0 8px" }}>
                    Nombre del proyecto
                  </label>
                  <br />
                  <Input
                    value={form.getFieldValue("nombreProyecto")}
                    disabled={isEditMode === false}
                  />

                  <label style={{ padding: "0 0 8px" }}>
                    Descripción del proyecto
                  </label>
                  <br />
                  <Input.TextArea
                    rows={7}
                    value={form.getFieldValue("descripcionProyecto")}
                    disabled={isEditMode !== false}
                  />
                </Col>

                <Col xs={12} sm={12}>
                  <h1
                    style={{
                      color: "#338BC7",
                      marginTop: "20px",
                      fontSize: "25px",
                    }}
                  >
                    Nuevos datos a registrar
                  </h1>
                  <Form.Item
                    label="Sector económico"
                    name="sector_economico_cambio"
                    rules={[
                      {
                        required: true,
                        message: "Por favor seleccione un sector económico",
                      },
                    ]}
                  >
                    <Select
                     disabled={isEditMode !== false}
                      value={tipoSectorSelecionado}
                      onChange={(value) => {
                        obtenerActividadesProductivasxSector(value);
                        // Buscar el nombre del sector correspondiente al ID seleccionado
                        const sectorSeleccionado = listaSectores.find(
                          (sector) => sector.id === value
                        );
                        setSectorEconomico_cambio_name(
                          sectorSeleccionado ? sectorSeleccionado.nombre : ""
                        ); // Almacena el nombre del sector económico
                      }}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {listaSectores.map((sector) => (
                        <Option key={sector.id} value={sector.id}>
                          {sector.nombre}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Actividad productiva"
                    name="ActividadesProductivas_cambio"
                    rules={[
                      {
                        required: true,
                        message: "Por favor seleccione la actividad productiva",
                      },
                    ]}
                  >
                    <Select
                      disabled={isEditMode || !tipoSectorSelecionado}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        // Buscar el nombre del sector correspondiente al ID seleccionado
                        const ActividadProductivaSeleccionada =
                          listaActividadesProductivas.find(
                            (actividad) => actividad.id === value
                          );
                        setActividadProductiva_cambio_name(
                          ActividadProductivaSeleccionada
                            ? ActividadProductivaSeleccionada.nombre
                            : ""
                        ); // Almacena el nombre del sector económico
                      }}
                    >
                      {listaActividadesProductivas.length > 0 ? (
                        listaActividadesProductivas.map((actividad) => (
                          <Option key={actividad.id} value={actividad.id}>
                            {actividad.nombre}
                          </Option>
                        ))
                      ) : (
                        <Option disabled>Cargando actividades...</Option>
                      )}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    label="Nombre Del Proyecto "
                    name="nombreProyecto_cambio"
                  >
                    <Input type="text" disabled={isEditMode !== false} />
                  </Form.Item>

                  <Form.Item
                    label="Descripción del proyecto"
                    name="descripcionProyecto_cambio"
                  >
                    <Input.TextArea rows={7} disabled={isEditMode !== false} />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label="Descripción de la novedad"
                name="descripcionNovedad"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la descripción de la novedad",
                  },
                ]}
              >
                <Input.TextArea rows={7} disabled={isEditMode === null} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={24}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span>
                  En constancia de lo anterior, firmo la presente novedad, en :{" "}
                </span>
              </div>
            </Col>
            <Col xs={24} sm={5}>
              <Form.Item
                label="Departamento de Novedad"
                name="departamentoNovedad"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione un departamento.",
                  },
                ]}
                style={{ margin: "8px 0", width: "100%" }}
              >
                <Select
                disabled={isEditMode === null}
                  placeholder="Seleccione un departamento"
                  onChange={handleDepartamentoNovedadChange}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {departamentos.map((depto) => (
                    <Option key={depto.id} value={depto.nombre}>
                      {depto.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={5}>
              <Form.Item
                label="Municipio de Novedad"
                name="municipioNovedad"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione un municipio.",
                  },
                ]}
                style={{ margin: "8px 0", width: "100%" }}
              >
                <Select
                disabled={isEditMode === null}
                  placeholder="Seleccione un municipio"
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {municipiosNovedad.map((mun) => (
                    <Option
                      key={mun.nombre_municipio}
                      value={mun.nombre_municipio}
                    >
                      {mun.nombre_municipio}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={4}>
              <Form.Item
                label="Días"
                name="diasNovedad"
                style={{ margin: "8px 0", width: "100%" }}
              >
                <Select
                  disabled={isEditMode === null}
                  placeholder="Días"
                  style={{ width: "100%" }}
                >
                  {Array.from({ length: 31 }, (_, i) => (
                    <Option key={i + 1} value={i + 1}>
                      {i + 1}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={5}>
              <Form.Item
                label="Mes"
                name="mesNovedad"
                style={{ margin: "8px 0", width: "100%" }}
              >
                <Select
                  disabled={isEditMode === null}
                  placeholder="Mes"
                  style={{ width: "100%" }}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {[
                    "Enero",
                    "Febrero",
                    "Marzo",
                    "Abril",
                    "Mayo",
                    "Junio",
                    "Julio",
                    "Agosto",
                    "Septiembre",
                    "Octubre",
                    "Noviembre",
                    "Diciembre",
                  ].map((mes, index) => (
                    <Option key={index} value={mes}>
                      {mes}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={5}>
              <Form.Item
                label="Año"
                name="anioNovedad"
                style={{ margin: "8px 0", width: "100%" }}
              >
                <Select
                disabled={isEditMode === null}
                  placeholder="Año"
                  style={{ width: "100%" }}
                >
                  {Array.from({ length: 5 }, (_, i) => (
                    <Option key={2024 + i} value={2024 + i}>
                      {2024 + i}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
         <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Form.Item label="Firma del titular" name="firmaTitular">
                <FirmaCanvas
                  label="Firma del titular"
                  name="firmaTitular"
                  form={form}
                  formLoaded={formLoaded}
                  disabledCambioFirma={isEditMode === null}
                />
              </Form.Item>
              <Form.Item label="Nombre:" name="nombreTitular">
                <Input disabled={isEditMode === null} />
              </Form.Item>
              <Form.Item label="C.C.:" name="ccTitular">
                <Input disabled={isEditMode === null} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item label="Firma  Profesional FAO" name="firmaContratista">
                <FirmaCanvas
                  label="FirmAa"
                  name="firmaContratista"
                  form={form}
                  formLoaded={formLoaded}
                  disabledCambioFirma={isEditMode === null}
                />
              </Form.Item>

              <Form.Item label="Nombre:" name="nombreContratista">
                <Input disabled={isEditMode === null} />
              </Form.Item>
              <Form.Item label="C.C.:" name="ccContratista">
                <Input disabled={isEditMode === null}/>
              </Form.Item>
            </Col>

          </Row>
{isEditMode !== null && (
  <div style={{ textAlign: "center", marginTop: "40px" }}>
    <Button
      type="primary"
      htmlType="submit"
      disabled={isLoading}
      style={{
        backgroundColor: "#52c41a",
        borderColor: "#52c41a",
      }}
    >
      {isEditMode === true
        ? "Actualizar novedad"
        : "Guardar Novedad"}
    </Button>
  </div>
)}



        </Form>

        {/* Modal para ingresar el código SIRR */}
        <Modal
          title="Consultar Código SIRR"
          open={modalVisible}
          footer={null}
          closable={true}
          onCancel={() => {
            setModalVisible(false);
            onClose();
          }}
        >
          <Input
            placeholder="Ingrese el código SIRR"
            value={codigoSIRRModal}
            onChange={(e) => setCodigoSIRRModal(e.target.value)}
            style={{ marginBottom: "16px" }}
          />
          <Button type="primary" onClick={handleConsultar}>
            Consultar
          </Button>
        </Modal>
      </Card>
    </div>
  );
};

export default FormularioNovedades;